import script from "./DaFa.vue?vue&type=script&setup=true&lang=js"
export * from "./DaFa.vue?vue&type=script&setup=true&lang=js"

import "./DaFa.vue?vue&type=style&index=0&id=45375089&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45375089"]])

export default __exports__